import React, { useEffect, useRef } from "react";

// SASS
import "./Part3.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import epaBuildingImg from "../../assets/img/EPA_fade.png";
import cloudsImg from "../../assets/img/clouds.png";
import arrowImg from "../../assets/img/arrow.png";

// FUNCTION EXPORT
export default function Part3({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "fade in clouds" },
    {
      stepNumber: "2",
      height: "750px",
      description: "move clouds on progress",
    },
    { stepNumber: "3", height: null, description: "spacer" },
  ];

  // REFS
  const cloudsEl = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "0": {
            animate.fadeInOnEnter(cloudsEl.current, direction);
            break;
          }
          case "2": {
            animate.addClassOnEnter(cloudsEl.current, "moved", direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        const step = element.dataset.step;
        switch (step) {
          // case "2": {
          //   moveClouds(progress);
          //   break;
          // }
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "0": {
            animate.fadeOutOnExit(cloudsEl.current, direction);
            break;
          }
          case "2": {
            animate.removeClassOnExit(cloudsEl.current, "moved", direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part3">
          <div className="building-container">
            <div className="clouds" ref={cloudsEl}>
              <img src={cloudsImg} alt="Clouds" className="img-fluid" />
            </div>
            <div className="sky"></div>
            <div className="building">
              <img
                src={epaBuildingImg}
                alt="EPA building"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="text-container">
            <div className="arrow arrow-left">
              <img src={arrowImg} alt="Arrow" className="img-fluid" />
            </div>
            <div className="arrow arrow-right">
              <img src={arrowImg} alt="Arrow" className="img-fluid" />
            </div>
            <div className="text">
              In the United States, the <br />
              Environmental Protection Agency (EPA) reviews and registers
              disinfectants <br />
              to ensure they are safe to <br />
              use in workplaces.
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description, offset }) => {
        return (
          <Step
            stepSection={step}
            stepNumber={stepNumber}
            stepDescription={description}
            height={height}
            key={stepNumber}
            offset={offset}
          />
        );
      })}
    </section>
  );
}
